import { createCustomEvent } from "../../../../javascript/shared/helpers";
import { makeSchedulable, SchedulablesController }   from "./schedulable_helpers";

export default makeSchedulable(class extends SchedulablesController {
  submitForOne(event) {
    event && event.preventDefault();
    this.emitSubmitEvent();
  }

  submitForAll(event) {
    event && event.preventDefault();
    this.emitSubmitEvent("1");
  }

  emitSubmitEvent(all) {
    document.dispatchEvent(
      createCustomEvent("schedulables:submit-repeat-action", this.element, { schedulableType: this.schedulableType, schedulableID: this.schedulableID, actionType: this.actionType, all })
    );
    App.Modal.closeAll();
  }

  cancelEdit(event) {
    App.Modal.closeAll();
  }

  //
  // GETTERS AND SETTERS
  //

  get schedulableType() {
    return this.data.get("schedulable-type")
  }

  get schedulableID() {
    return this.data.get("schedulable-id");
  }

  get actionType() {
    return this.data.get("action-type");
  }
});



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-repeat-update-prompt-controller.js